module.exports = __webpack_public_path__ + "static/media/open_quote.aa19e802.svg";